import { SweetAlertResult } from 'sweetalert2';
import { makeStyles, Theme } from '@material-ui/core/styles';
import getBaseSweetAlert from './get-base-sweet-alert';
import { SweetAlertHookApi, OpenAlertOptions } from 'types';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    ...theme.typography.h4
  },
  container: {
    zIndex: theme.zIndex.modal + 1
  },
  content: {
    ...theme.typography.body2,
    marginTop: theme.spacing(2),
    fontWeight: 300,
    fontSize: '1.125em'
  },
  popup: {
    width: '28em',
    borderRadius: '8px'
  },
  confirmButton: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(21),
    backgroundColor: `${theme.palette.primary.main} !important`,
    borderRadius: '24px !important'
  },
  cancelButton: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(21),
    backgroundColor: `${theme.palette.common.white} !important`,
    borderRadius: '24px !important',
    border: `1px solid ${theme.palette.grey[700]} !important`,
    color: `${theme.palette.common.black} !important`,
    '&:active': {
      background: theme.palette.grey[300]
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
      border: `1px solid ${theme.palette.grey[700]}`
    }
  }
}));

const useConfirmAlert = (): SweetAlertHookApi => {
  const classes = useStyles();
  const SweetAlert = getBaseSweetAlert({
    icon: 'warning',
    customClass: {
      title: classes.title,
      container: classes.container,
      content: classes.content,
      popup: classes.popup,
      confirmButton: classes.confirmButton,
      cancelButton: classes.cancelButton
    }
  });

  const open = (
    {
      onCancel,
      onSubmit,
      ...rest
    }: Omit<
      OpenAlertOptions,
      'showConfirmButton' | 'showCancelButton' | 'showCloseButton' | 'reverseButtons'
    > = {} as OpenAlertOptions
  ): Promise<void> => {
    return SweetAlert.fire({
      showConfirmButton: true,
      showCancelButton: true,
      showCloseButton: false,
      reverseButtons: true,
      ...rest
    }).then(async (result: SweetAlertResult | void) => {
      if (result && result.value && onSubmit) {
        return onSubmit(result);
      } else if (onCancel) {
        return onCancel();
      }
    });
  };

  return {
    open
  };
};

export default useConfirmAlert;
